<template>
  <qx-card title="时效罚款" :noTitle="true" style="padding-top: 8px">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="承运方时效" name="carrier" componentName="carrier">
        <Carrier ref="carrier" />
      </el-tab-pane>
      <el-tab-pane label="客户时效" name="customer" componentName="customer">
        <Customer ref="customer" />
      </el-tab-pane>
      <!-- <el-tab-pane label="报备" name="report" componentName="report">
        <Report ref="report" />
      </el-tab-pane> -->
      <!-- <el-tab-pane label="司机更换记录" name="driver" componentName="driver">
        <Driver ref="driver" />
      </el-tab-pane> -->
    </el-tabs>
  </qx-card>
</template>

<script>
import Carrier from '../carrier/carrier.vue';
import Customer from '../customer/customer.vue';
// import Report from '../report/report.vue';
// import Driver from '../driver/driver.vue';
export default {
  components: {
    Carrier,
    Customer,
    // Report,
    // Driver,
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler (newValue) {
        const name = `${newValue}`;
        const tabMenu = sessionStorage.getItem('tabMenu');
        const preTabMenuList = this.preTabMenu ? JSON.parse(this.preTabMenu) : [];
        // 查找之前是否打开过这个链接，判断是否第一次进来
        const tabIndex = preTabMenuList.findIndex((item) => item.url === newValue);

        if (tabIndex === -1) {
          this.ctrlActiveTab[name] = undefined;
        }
        this.preTabMenu = tabMenu;

        if (this.ctrlActiveTab[name] === undefined) {
          // 第一次打开 tab
          let defaultActive = 'carrier';
          if (this.$route.query.defaultChildActive) {
            defaultActive = this.$route.query.defaultChildActive;
          }
          this.ctrlActiveTab[name] = defaultActive;
          this.activeName = defaultActive;
        } else {
          // 来回切换 tab 的时候，回填之前的值
          this.activeName = this.ctrlActiveTab[name];
        }
      },
    },
  },
  data () {
    return {
      activeName: 'carrier',
      ctrlActiveTab: {},
      preTabMenu: '',
    };
  },
  methods: {
    getData () {
      this.$refs.carrier.getData();
    },
    handleClick (tab) {
      this.$refs[tab.name].getData();
      // 切换历史保存
      this.ctrlActiveTab[`${this.$route.fullPath}`] = tab.name;
      this.$emit('change', tab.name);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
